import {
  LayoutDashboard,
  Search,
  ListChecks,
  Briefcase,
  Building2,
  Users,
  BarChart3,
  FolderOpen,
} from "lucide-react";
import type { ComponentType, SVGProps } from "react";

export type NavItem = {
  href: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  chip?: string;
};

export type NavSection = {
  id: string;
  label?: string;
  items: NavItem[];
};

/** Job-search–first side nav. Goals / AI / CV / Settings live in the top bar. */
export const NAV_SECTIONS: NavSection[] = [
  {
    id: "command",
    items: [{ href: "/", label: "Moves", icon: LayoutDashboard }],
  },
  {
    id: "work",
    label: "Work",
    items: [
      { href: "/jobs", label: "Jobs", icon: Briefcase },
      { href: "/pipeline", label: "Pipeline", icon: ListChecks },
    ],
  },
  {
    id: "discover",
    label: "Discover",
    items: [
      { href: "/explore", label: "Find Jobs", icon: Search },
      { href: "/companies", label: "Employers", icon: Building2 },
      { href: "/network", label: "Network", icon: Users },
    ],
  },
  {
    id: "insights",
    label: "Insights",
    items: [{ href: "/analytics", label: "Analytics", icon: BarChart3 }],
  },
  {
    id: "tools",
    label: "Tools",
    items: [{ href: "/assets", label: "Assets", icon: FolderOpen }],
  },
];

/** Flat list for mobile drawer / lookups. */
export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((s) => s.items);

const NAV_COLLAPSED_KEY = "career-ops:nav-collapsed";

export function loadNavCollapsed(): boolean {
  try {
    return localStorage.getItem(NAV_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistNavCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(NAV_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function isActivePath(href: string, pathname: string): boolean {
  if (href === "/") return pathname === "/";
  if (href === "/profile") {
    return pathname === "/profile" || pathname.startsWith("/profile/");
  }
  if (href === "/settings/ai" || href.startsWith("/settings")) {
    return pathname.startsWith("/settings");
  }
  return pathname.startsWith(href);
}
